import storiboxLogo from 'url:../../img/logo-rgb-v.png';
import { Account } from './data.ts';
import { formatDate, addDays } from '../utils/dates.ts';

const containerCSSPath = '.multi-accounts';
let subscribed = false;
export function render(list: Account[], currentIndex: number) {
  if (list.length === 0) return;

  const multiAccountsTemplateList = list
    .map((account, index) => accountTemplate({ account, index, isActive: index === currentIndex }))
    .join('');
  renderListTemplate(multiAccountsTemplateList);
  show();

  restoreScrollPosition();
  if (!subscribed) {
    onScroll(saveScrollPosition);
    subscribed = true;
  }
}

export function onSelectAccount(callback: (index: number) => void) {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    container.addEventListener('click', (event: Event) => {
      const target = event.target as HTMLElement;
      const item = target.closest('.multi-accounts__item') as HTMLElement;
      if (item) {
        const index = Number(item.dataset.index);
        callback(index);
      }
    });
  }
}

export function activeAccount(index: number) {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    const items = container.querySelectorAll('.multi-accounts__item');
    items.forEach((item) => {
      const itemElement = item as HTMLElement;
      item.classList.toggle('multi-accounts__item_active', Number(itemElement.dataset.index) === index);
    });
  }
}

function renderListTemplate(str: string) {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    container.innerHTML = str;
  }
}

function show() {
  const container = document.querySelector('.multi-accounts');
  if (container) {
    container.classList.remove('multi-accounts_hidden');
  }
}

function accountTemplate({ account, index, isActive }: { index: number; account: Account; isActive: boolean }) {
  const logo = account.eventLogo || storiboxLogo;
  const registeredDate = formatDate(account.regDate);
  const expiredDate = account.expiredDate ? formatDate(account.expiredDate) : '';
  const isShowExpiredDate = isExpiredSoon(account);
  return `
    <div class="multi-accounts__item${isActive ? ' multi-accounts__item_active' : ''}" data-index="${index}">
        <img class="multi-accounts__logo" src="${logo}" alt="logo-${account.eventCode}" />
        <div class="multi-accounts__register-date${isShowExpiredDate ? ' multi-accounts__register-date_hidden' : ''}">
          ${registeredDate}
        </div>
        <div class="multi-accounts__expired-date${!isShowExpiredDate ? ' multi-accounts__expired-date_hidden' : ''}">
          Expired on ${expiredDate}
        </div>
    </div>
  `;
}

function isExpiredSoon(account: Account) {
  if (!account.expiredDate) return false;
  const today = new Date();
  const tenDaysBeforeExpiration = addDays(account.expiredDate, -10);
  return today >= tenDaysBeforeExpiration && today <= account.expiredDate;
}

function saveScrollPosition() {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    localStorage.setItem('multiAccountsScrollX', container.scrollLeft.toString());
  }
}

function restoreScrollPosition() {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    const savedScroll = localStorage.getItem('multiAccountsScrollX');
    if (savedScroll) {
      container.scrollLeft = Number(savedScroll);
    }
  }
}

function onScroll(cb: () => void) {
  const container = document.querySelector(containerCSSPath);
  if (container) {
    container.addEventListener('scroll', cb);
  }
}
